module.exports = __webpack_public_path__ + "img/jp.54499f57.svg";